/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import ExampleLoading from 'react-scale/components/website/index/Products/examples/exampleLoading';

const TaskResponseAnnotation = dynamic(
  () => import('react-scale/components/website/index/Products/examples/tasks/annotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

const response = {
  annotations: [
    {
      width: 116,
      height: 123,
      left: 41,
      top: 0,
      label: 'container'
    },
    {
      width: 105,
      height: 124,
      left: 151,
      top: 0,
      label: 'container'
    },
    {
      width: 105,
      height: 120,
      left: 274,
      top: 0,
      label: 'container'
    },
    {
      width: 112,
      height: 118,
      left: 369,
      top: 0,
      label: 'container'
    },
    {
      width: 105,
      height: 120,
      left: 476,
      top: 0,
      label: 'container'
    },
    {
      width: 115,
      height: 125,
      left: 596,
      top: 0,
      label: 'container'
    },
    {
      width: 108,
      height: 127,
      left: 701,
      top: 0,
      label: 'container'
    },
    {
      width: 109,
      height: 121,
      left: 923,
      top: 0,
      label: 'container'
    },
    {
      width: 107,
      height: 129,
      left: 1025,
      top: 0,
      label: 'container'
    },
    {
      width: 113,
      height: 129,
      left: 1118,
      top: 0,
      label: 'container'
    },
    {
      width: 109,
      height: 123,
      left: 1250,
      top: 0,
      label: 'container'
    },
    {
      width: 110,
      height: 122,
      left: 1357,
      top: 0,
      label: 'container'
    },
    {
      width: 105,
      height: 125,
      left: 1460,
      top: 0,
      label: 'container'
    },
    {
      width: 116,
      height: 128,
      left: 1577,
      top: 0,
      label: 'container'
    },
    {
      width: 111,
      height: 132,
      left: 1686,
      top: 0,
      label: 'container'
    },
    {
      width: 104,
      height: 132,
      left: 1730,
      top: 0,
      label: 'container'
    },
    {
      width: 64,
      height: 133,
      left: 0,
      top: 112,
      label: 'container'
    },
    {
      width: 174,
      height: 130,
      left: 26,
      top: 113,
      label: 'container'
    },
    {
      width: 132,
      height: 126,
      left: 259,
      top: 119,
      label: 'container'
    },
    {
      width: 138,
      height: 130,
      left: 359,
      top: 114,
      label: 'container'
    },
    {
      width: 137,
      height: 148,
      left: 467,
      top: 98,
      label: 'container'
    },
    {
      width: 128,
      height: 136,
      left: 595,
      top: 111,
      label: 'container'
    },
    {
      width: 97,
      height: 131,
      left: 807,
      top: 115,
      label: 'container'
    },
    {
      width: 101,
      height: 131,
      left: 929,
      top: 117,
      label: 'container'
    },
    {
      width: 126,
      height: 143,
      left: 1115,
      top: 105,
      label: 'container'
    },
    {
      width: 113,
      height: 130,
      left: 1256,
      top: 121,
      label: 'container'
    },
    {
      width: 136,
      height: 131,
      left: 1335,
      top: 120,
      label: 'container'
    },
    {
      width: 138,
      height: 128,
      left: 1432,
      top: 123,
      label: 'container'
    },
    {
      width: 131,
      height: 128,
      left: 1565,
      top: 123,
      label: 'container'
    },
    {
      width: 90,
      height: 121,
      left: 1744,
      top: 124,
      label: 'container'
    },
    {
      width: 90,
      height: 120,
      left: 0,
      top: 248,
      label: 'container'
    },
    {
      width: 158,
      height: 126,
      left: 120,
      top: 242,
      label: 'container'
    },
    {
      width: 131,
      height: 127,
      left: 245,
      top: 243,
      label: 'container'
    },
    {
      width: 133,
      height: 132,
      left: 355,
      top: 233,
      label: 'container'
    },
    {
      width: 112,
      height: 121,
      left: 457,
      top: 247,
      label: 'container'
    },
    {
      width: 121,
      height: 124,
      left: 585,
      top: 245,
      label: 'container'
    },
    {
      width: 113,
      height: 119,
      left: 690,
      top: 250,
      label: 'container'
    },
    {
      width: 100,
      height: 123,
      left: 928,
      top: 249,
      label: 'container'
    },
    {
      width: 120,
      height: 122,
      left: 1125,
      top: 251,
      label: 'container'
    },
    {
      width: 115,
      height: 123,
      left: 1262,
      top: 250,
      label: 'container'
    },
    {
      width: 116,
      height: 122,
      left: 1371,
      top: 252,
      label: 'container'
    },
    {
      width: 141,
      height: 122,
      left: 1446,
      top: 251,
      label: 'container'
    },
    {
      width: 116,
      height: 126,
      left: 1601,
      top: 253,
      label: 'container'
    },
    {
      width: 131,
      height: 124,
      left: 1696,
      top: 251,
      label: 'container'
    },
    {
      width: 117,
      height: 115,
      left: 235,
      top: 381,
      label: 'container'
    },
    {
      width: 153,
      height: 118,
      left: 335,
      top: 379,
      label: 'container'
    },
    {
      width: 119,
      height: 116,
      left: 586,
      top: 381,
      label: 'container'
    },
    {
      width: 118,
      height: 116,
      left: 687,
      top: 381,
      label: 'container'
    },
    {
      width: 106,
      height: 117,
      left: 799,
      top: 382,
      label: 'container'
    },
    {
      width: 103,
      height: 113,
      left: 926,
      top: 386,
      label: 'container'
    },
    {
      width: 111,
      height: 112,
      left: 1026,
      top: 385,
      label: 'container'
    },
    {
      width: 119,
      height: 113,
      left: 1267,
      top: 386,
      label: 'container'
    },
    {
      width: 120,
      height: 112,
      left: 1371,
      top: 389,
      label: 'container'
    },
    {
      width: 119,
      height: 111,
      left: 1481,
      top: 389,
      label: 'container'
    },
    {
      width: 134,
      height: 118,
      left: 1604,
      top: 383,
      label: 'container'
    },
    {
      width: 133,
      height: 118,
      left: 1700,
      top: 387,
      label: 'container'
    },
    {
      width: 95,
      height: 86,
      left: 0,
      top: 519,
      label: 'container'
    },
    {
      width: 123,
      height: 83,
      left: 83,
      top: 521,
      label: 'container'
    },
    {
      width: 109,
      height: 84,
      left: 444,
      top: 522,
      label: 'container'
    },
    {
      width: 130,
      height: 88,
      left: 568,
      top: 519,
      label: 'container'
    },
    {
      width: 107,
      height: 83,
      left: 920,
      top: 525,
      label: 'container'
    },
    {
      width: 139,
      height: 80,
      left: 1248,
      top: 529,
      label: 'container'
    },
    {
      width: 125,
      height: 81,
      left: 1364,
      top: 510,
      label: 'container'
    },
    {
      width: 169,
      height: 84,
      left: 1569,
      top: 530,
      label: 'container'
    },
    {
      width: 106,
      height: 86,
      left: 1728,
      top: 674,
      label: 'container'
    },
    {
      width: 121,
      height: 84,
      left: 1502,
      top: 675,
      label: 'container'
    },
    {
      width: 122,
      height: 87,
      left: 1387,
      top: 674,
      label: 'container'
    },
    {
      width: 115,
      height: 86,
      left: 1278,
      top: 672,
      label: 'container'
    },
    {
      width: 111,
      height: 87,
      left: 1147,
      top: 672,
      label: 'container'
    },
    {
      width: 117,
      height: 87,
      left: 1031,
      top: 671,
      label: 'container'
    },
    {
      width: 107,
      height: 86,
      left: 922,
      top: 654,
      label: 'container'
    },
    {
      width: 107,
      height: 86,
      left: 792,
      top: 672,
      label: 'container'
    },
    {
      width: 119,
      height: 86,
      left: 674,
      top: 670,
      label: 'container'
    },
    {
      width: 147,
      height: 85,
      left: 429,
      top: 652,
      label: 'container'
    },
    {
      width: 109,
      height: 92,
      left: 0,
      top: 662,
      label: 'container'
    },
    {
      width: 123,
      height: 89,
      left: 671,
      top: 824,
      label: 'container'
    },
    {
      width: 119,
      height: 129,
      left: 921,
      top: 783,
      label: 'container'
    },
    {
      width: 133,
      height: 133,
      left: 1127,
      top: 781,
      label: 'container'
    },
    {
      width: 120,
      height: 90,
      left: 1284,
      top: 791,
      label: 'container'
    },
    {
      width: 121,
      height: 90,
      left: 1399,
      top: 791,
      label: 'container'
    },
    {
      width: 154,
      height: 97,
      left: 1619,
      top: 820,
      label: 'container'
    },
    {
      width: 159,
      height: 110,
      left: 1468,
      top: 933,
      label: 'container'
    },
    {
      width: 160,
      height: 103,
      left: 1368,
      top: 975,
      label: 'container'
    },
    {
      width: 136,
      height: 105,
      left: 1137,
      top: 973,
      label: 'container'
    },
    {
      width: 121,
      height: 93,
      left: 1030,
      top: 983,
      label: 'container'
    },
    {
      width: 119,
      height: 102,
      left: 917,
      top: 975,
      label: 'container'
    },
    {
      width: 161,
      height: 121,
      left: 735,
      top: 957,
      label: 'container'
    },
    {
      width: 168,
      height: 115,
      left: 559,
      top: 957,
      label: 'container'
    },
    {
      width: 158,
      height: 116,
      left: 372,
      top: 948,
      label: 'container'
    },
    {
      width: 216,
      height: 155,
      left: 365,
      top: 984,
      label: 'container'
    },
    {
      width: 128,
      height: 112,
      left: 1706,
      top: 972,
      label: 'container'
    },
    {
      width: 204,
      height: 120,
      left: 177,
      top: 951,
      label: 'container'
    },
    {
      width: 140,
      height: 111,
      left: 28,
      top: 964,
      label: 'container'
    },
    {
      width: 56,
      height: 99,
      left: 0,
      top: 975,
      label: 'container'
    },
    {
      width: 99,
      height: 97,
      left: 1735,
      top: 822,
      label: 'container'
    },
    {
      width: 123,
      height: 93,
      left: 1625,
      top: 670,
      label: 'container'
    },
    {
      width: 111,
      height: 82,
      left: 1723,
      top: 532,
      label: 'container'
    }
  ]
};

export default () => (
  <TaskResponseAnnotation
    hover
    imageURL="/static/img/website/solutions/ar-vr/slider/slide-1.jpg"
    annotations={response.annotations}
    bgTransparent
    responsive
    imageZoomFactor={0.5}
    rounded
  />
);
